import React, { useState, useEffect } from 'react';
import './App.css';
import './MemoryDAG.css';
import ZepMemory from './ZepMemory';
import Form8038G from './Form8038G';
import ComplianceManualBuilder from './ComplianceManualBuilder';
import YieldCalculator from './components/YieldCalculator';
import LoanYieldCalculator from './components/LoanYieldCalculator';
import WAMCalculator from './components/WAMCalculator';
import TaxDisclosure from './components/TaxDisclosure';
import Form8038 from './components/Form8038';
import DocumentViewer from './components/DocumentViewer';
import TransactionReviewPanel from './components/TransactionReviewPanel';
import TaxCertificate from './components/TaxCertificate';
import LanguageLibrary from './components/LanguageLibrary';
import V2Chat from './components/V2Chat';
import TopBar from './components/TopBar';
import Login from './components/Login';

import { useTheme } from './hooks/useTheme';
import { useCustomPrompt } from './hooks/useCustomPrompt';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    fetch('/api/auth/check')
      .then(res => {
        if (res.ok) {
          setIsAuthenticated(true);
          setCurrentUser(localStorage.getItem('pft_user') || 'default_user');
        } else {
          setIsAuthenticated(false);
          localStorage.removeItem('pft_authenticated');
        }
      })
      .catch(() => setIsAuthenticated(false))
      .finally(() => setAuthChecked(true));
  }, []);

  const [selectedModel, setSelectedModel] = useState('gpt-4o');
  const [activeTab, setActiveTab] = useState('v2chat');
  const [showDocViewer, setShowDocViewer] = useState(false);
  const [docViewerQuery, setDocViewerQuery] = useState('');

  const { isDarkTheme, toggleTheme } = useTheme();
  const {
    customPrompt,
    promptInputValue,
    setPromptInputValue,
    showPromptEditor,
    setShowPromptEditor,
    updateCustomPrompt,
    resetToDefaultPrompt
  } = useCustomPrompt();

  const handleLogin = (username) => {
    setIsAuthenticated(true);
    setCurrentUser(username || 'default_user');
    localStorage.setItem('pft_authenticated', 'true');
    localStorage.setItem('pft_user', username || 'default_user');
  };

  if (!authChecked) return null;
  if (!isAuthenticated) return <Login onLogin={handleLogin} />;

  return (
    <div className="app">
      <div className="main-content">
        <TopBar
          selectedModel={selectedModel}
          setSelectedModel={setSelectedModel}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          isDarkTheme={isDarkTheme}
          toggleTheme={toggleTheme}
          customPrompt={customPrompt}
          promptInputValue={promptInputValue}
          setPromptInputValue={setPromptInputValue}
          showPromptEditor={showPromptEditor}
          setShowPromptEditor={setShowPromptEditor}
          updateCustomPrompt={updateCustomPrompt}
          resetToDefaultPrompt={resetToDefaultPrompt}
          showDocViewer={showDocViewer}
          setShowDocViewer={setShowDocViewer}
        />

        {activeTab === 'txreview' && (
          <TransactionReviewPanel onBack={() => setActiveTab('v2chat')} />
        )}
        {activeTab === '8038g' && <Form8038G />}
        {activeTab === 'complianceManual' && <ComplianceManualBuilder />}
        {activeTab === 'memory' && <ZepMemory />}
        {activeTab === 'yieldCalc' && <YieldCalculator />}
        {activeTab === 'loanYieldCalc' && <LoanYieldCalculator />}
        {activeTab === 'wamCalc' && <WAMCalculator />}
        {activeTab === 'disclosure' && <TaxDisclosure />}
        {activeTab === '8038' && <Form8038 />}
        {activeTab === 'taxCert' && <TaxCertificate />}
        {activeTab === 'languageLib' && <LanguageLibrary />}
        {activeTab === 'v2chat' && <V2Chat />}
      </div>

      {showDocViewer && (
        <DocumentViewer query={docViewerQuery} onClose={() => { setShowDocViewer(false); setDocViewerQuery(''); }} />
      )}
    </div>
  );
};

export default App;
